// extracted by mini-css-extract-plugin
module.exports = {"index":"columns_index__Rx6ys","commonColumn":"columns_commonColumn__mwX4o","orgNameForProductNameColumn":"columns_orgNameForProductNameColumn__ZaQB7"};